import request from "@/utils/request";

// --------------------- 项目管理 ---------------------
/**
 * [查询][列表]获取项目服务单列表
 */
export const getProjectTaskList = () => {
    return request.get(`/projectTask/list`);
}
/**
 * [查询][分页]获取项目列表
 * @param params     查询条件
 */
export const getProjectTaskPage = (params) => {
    return request.get(`/projectTask/page`, {params});
}

// --------------------- 项目服务单 ---------------------
/**
 * [查询][列表]获取项目服务单列表
 */
export const getProjectServiceOrderList = () => {
    return request.get(`/projectServiceOrder/list`);
}
/**
 * [查询][分页]获取项目服务单列表
 * @param params     查询条件
 */
export const getProjectServiceOrderPage = (params) => {
    return request.get(`/projectServiceOrder/page`, {params});
}

/**
 * [查询]获取单个项目服务单详情
 * @param id     项目服务单id
 */
export const getProjectServiceOrderInfo = (id) => {
    return request.get(`/projectServiceOrder/info/${id}`);
}

/**
 * [查询]获取单个项目服务单信息
 * @param id     项目服务单id
 */
export const getProjectServiceOrder = (id) => {
    return request.get(`/projectServiceOrder/${id}`);
}

/**
 * [新增]添加项目服务单
 * @param data   项目服务单数据
 */
export const addProjectServiceOrder = (data) => {
    return request.post(`/projectServiceOrder`, data);
}

/**
 * [修改]更新项目服务单
 * @param data   项目服务单数据
 */
export const updateProjectServiceOrder = (data) => {
    return request.put(`/projectServiceOrder`, data);
}

/**
 * [删除]删除项目服务单
 * @param id     项目服务单id
 */
export const deleteProjectServiceOrder = (id) => {
    return request.delete(`/projectServiceOrder/${id}`);
}

/**
 * [导出]导出项目服务单数据
 * @param params 导出参数 (如果为空则导出全部)
 */
export const exportProjectServiceOrder = (params) => {
    return request.get(`/projectServiceOrder/export`, {
        params,
        responseType: 'blob',
        timeout: 300000 // 设置超时时间为300秒
    });
}

/**
 * [导入]导入项目服务单数据
 * @param file   Excel文件
 */
export const importProjectServiceOrder = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return request.post(`/projectServiceOrder/import`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

/**
 * [下载]下载项目服务单导入模板
 */
export const downloadProjectServiceOrderTemplate = () => {
    return request.get(`/projectServiceOrder/template`, {
        responseType: 'blob'
    });
}

/**
 * TODO 后端待实现
 * [生成工单]根据项目服务单生成工单
 * @param data   生成工单的数据
 */
export const createWorkOrderFromServiceOrder = (data) => {
    return request.post(`/workorderInfo/createFromServiceOrder`, data);
}

// --------------------- 项目工单 ---------------------
/**
 * [查询][分页]获取项目工单列表
 * @param params     查询条件
 */
export const getWorkOrderPage = (params) => {
    return request.get(`/workorderInfo/page`, {params});
}

/**
 * [查询][详情]获取单个项目工单详情
 * @param id     项目工单id
 */
export const getWorkOrderInfo = (id) => {
    return request.get(`/workorderInfo/info/${id}`);
}

/**
 * [查询]获取单个项目工单信息
 * @param id     项目工单id
 */
export const getWorkOrder = (id) => {
    return request.get(`/workorderInfo/${id}`);
}

/**
 * [新增]添加项目工单
 * @param data   项目工单数据
 */
export const addWorkOrder = (data) => {
    return request.post(`/workorderInfo`, data);
}

/**
 * [修改]更新项目工单
 * @param data   项目工单数据
 */
export const updateWorkOrder = (data) => {
    return request.put(`/workorderInfo`, data);
}

/**
 * [删除]删除项目工单
 * @param id     项目工单id
 */
export const deleteWorkOrder = (id) => {
    return request.delete(`/workorderInfo/${id}`);
}

/**
 * [导出]导出项目工单数据
 * @param params 导出参数 (如果为空则导出全部)
 */
export const exportWorkOrder = (params) => {
    return request.get(`/workorderInfo/export`, {
        params,
        responseType: 'blob',
        timeout: 300000 // 设置超时时间为300秒
    });
}

/**
 * [导出]导出项目工单及其子表数据
 * @param params 导出参数 (如果为空则导出全部)
 */
export const exportWorkOrderV2 = (params) => {
    return request.get(`/workorderInfo/exportv2`, {
        params,
        responseType: 'blob',
        timeout: 300000 // 设置超时时间为300秒
    });
}

/**
 * [导入]导入项目工单数据
 * @param file   Excel文件
 */
export const importWorkOrder = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return request.post(`/workorderInfo/import`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

/**
 * [审批]审批工单
 */
export const approveWorkOrder = (data) => {
    return request.put(`/workorderInfo/approve`, data);
}

/** TODO 后端待实现
 * [临时工单转普通工单]转换工单类型
 * @param id     工单id
 */
export const convertTempToNormal = (id) => {
    return request.put(`/workorderInfo/${id}/convertTempToNormal`);
}

/** TODO 后端待实现
 * [普通工单转临时工单]转换工单类型
 * @param id     工单id
 */
export const convertNormalToTemp = (id) => {
    return request.put(`/workorderInfo/${id}/convertNormalToTemp`);
}

/** TODO 后端待实现
 * [协同工单转普通工单]转换工单类型
 * @param id     工单id
 */
export const convertCollaborativeToNormal = (id) => {
    return request.put(`/workorderInfo/${id}/convertCollaborativeToNormal`);
}

/** TODO 后端待实现
 * [普通工单转协同工单]转换工单类型
 * @param id     工单id
 */
export const convertNormalToCollaborative = (id) => {
    return request.put(`/workorderInfo/${id}/convertNormalToCollaborative`);
}

/**
 * [生成PDF]根据工单ID生成PDF文件
 * @param workorderId 工单ID
 */
export const genWorkOrderPdf = (workorderId) => {
    return request.post(`/workorderInfo/genPdf?workorderId=${workorderId}`, null, {
        timeout: 30000 // 设置超时时间为30秒
    });
}

// --------------------- 项目工单-审批记录 ---------------------
/**
 * [新增]添加审批记录
 * @param data   审批记录数据
 */
export const addApproval = (data) => {
    return request.post(`/workorderApprovalRecord`, data, {
        timeout: 30000 // 设置超时时间为30秒
    });
}

// --------------------- 项目工单-行动项目 ---------------------
/**
 * [查询][列表]获取工单行动项目列表
 * @param params 查询条件
 */
export const getWorkOrderActionItemList = (params) => {
    return request.get(`/workorderActionItem/list`, {params});
}

/**
 * [新增]添加工单行动项目
 * @param data 行动项目数据
 */
export const addWorkOrderActionItem = (data) => {
    return request.post(`/workorderActionItem`, data);
}

/**
 * [修改]更新工单行动项目
 * @param data 行动项目数据
 */
export const updateWorkOrderActionItem = (data) => {
    return request.put(`/workorderActionItem`, data);
}

/**
 * [删除]删除工单行动项目
 * @param id 行动项目id
 */
export const deleteWorkOrderActionItem = (id) => {
    return request.delete(`/workorderActionItem/${id}`);
}

// --------------------- 项目工单-虫情勘察 ---------------------
/**
 * [查询][列表]获取工单虫情勘察列表
 * @param params 查询条件
 */
export const getWorkOrderPestSurveyList = (params) => {
    return request.get(`/workorderPestSurvey/list`, {params});
}

/**
 * [新增]添加工单虫情勘察
 * @param data 虫情勘察数据
 */
export const addWorkOrderPestSurvey = (data) => {
    return request.post(`/workorderPestSurvey`, data);
}

/**
 * [修改]更新工单虫情勘察
 * @param data 虫情勘察数据
 */
export const updateWorkOrderPestSurvey = (data) => {
    return request.put(`/workorderPestSurvey`, data);
}

/**
 * [删除]删除工单虫情勘察
 * @param id 虫情勘察id
 */
export const deleteWorkOrderPestSurvey = (id) => {
    return request.delete(`/workorderPestSurvey/${id}`);
}

// --------------------- 项目工单-设备详情 ---------------------
/**
 * [查询][列表]获取工单设备详情列表
 * @param params 查询条件
 */
export const getWorkOrderDeviceDetailList = (params) => {
    return request.get(`/workorderDeviceDetail/list`, {params});
}

/**
 * [新增]添加工单设备详情
 * @param data 设备详情数据
 */
export const addWorkOrderDeviceDetail = (data) => {
    return request.post(`/workorderDeviceDetail`, data);
}

/**
 * [修改]更新工单设备详情
 * @param data 设备详情数据
 */
export const updateWorkOrderDeviceDetail = (data) => {
    return request.put(`/workorderDeviceDetail`, data);
}

/**
 * [删除]删除工单设备详情
 * @param id 设备详情id
 */
export const deleteWorkOrderDeviceDetail = (id) => {
    return request.delete(`/workorderDeviceDetail/${id}`);
}

// --------------------- 项目工单-物料汇总 ---------------------
/**
 * [查询][列表]获取工单物料汇总列表
 * @param params 查询条件
 */
export const getWorkOrderMaterialSummaryList = (params) => {
    return request.get(`/workorderMaterialSummary/list`, {params});
}

/**
 * [新增]添加工单物料汇总
 * @param data 物料汇总数据
 */
export const addWorkOrderMaterialSummary = (data) => {
    return request.post(`/workorderMaterialSummary`, data);
}

/**
 * [修改]更新工单物料汇总
 * @param data 物料汇总数据
 */
export const updateWorkOrderMaterialSummary = (data) => {
    return request.put(`/workorderMaterialSummary`, data);
}

/**
 * [删除]删除工单物料汇总
 * @param id 物料汇总id
 */
export const deleteWorkOrderMaterialSummary = (id) => {
    return request.delete(`/workorderMaterialSummary/${id}`);
}

/**
 * [文件上传]上传文件到服务器
 * @param file   要上传的文件
 */
export const uploadFile = (file) => {
    const formData = new FormData();
    formData.append('file', file); // 确保参数名是 'file'
    return request.post(`/files/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

// --------------------- 项目工单-签到记录 ---------------------
/**
 * [查询][列表]获取工单签到记录列表
 * @param params 查询条件
 */
export const getWorkOrderCheckinRecordList = (params) => {
    return request.get(`/workorderCheckinRecord/list`, {params});
}

/**
 * [新增]添加工单签到记录
 * @param data 签到记录数据
 */
export const addWorkOrderCheckinRecord = (data) => {
    return request.post(`/workorderCheckinRecord`, data);
}

/**
 * [修改]更新工单签到记录
 * @param data 签到记录数据
 */
export const updateWorkOrderCheckinRecord = (data) => {
    return request.put(`/workorderCheckinRecord`, data);
}

/**
 * [删除]删除工单签到记录
 * @param id 签到记录id
 */
export const deleteWorkOrderCheckinRecord = (id) => {
    return request.delete(`/workorderCheckinRecord/${id}`);
}

// --------------------- 项目工单-扩展信息 ---------------------
/**
 * [查询][列表]获取工单扩展信息列表
 * @param params 查询条件
 */
export const getWorkOrderExtensionInfoList = (params) => {
    return request.get(`/workorderExtensionInfo/list`, {params});
}

/**
 * [新增]添加工单扩展信息
 * @param data 扩展信息数据
 */
export const addWorkOrderExtensionInfo = (data) => {
    return request.post(`/workorderExtensionInfo`, data);
}

/**
 * [修改]更新工单扩展信息
 * @param data 扩展信息数据
 */
export const updateWorkOrderExtensionInfo = (data) => {
    return request.put(`/workorderExtensionInfo`, data);
}

/**
 * [删除]删除工单扩展信息
 * @param id 扩展信息id
 */
export const deleteWorkOrderExtensionInfo = (id) => {
    return request.delete(`/workorderExtensionInfo/${id}`);
}

/**
 * [查询]获取门店定制配置列表
 * @param id 工单ID
 */
export const getStoreCustomConfigList = (id) => {
    return request.get(`/workorderInfo/storeCustomConfigs/${id}`);
}

// --------------------- 项目工单-签字记录 ---------------------
/**
 * [查询][列表]获取工单签字记录列表
 * @param params 查询条件
 */
export const getWorkOrderSignatureRecordList = (params) => {
    return request.get(`/workorderSignatureRecord/list`, {params});
}

/**
 * [新增]添加工单签字记录
 * @param data 签字记录数据
 */
export const addWorkOrderSignatureRecord = (data) => {
    return request.post(`/workorderSignatureRecord`, data);
}

/**
 * [修改]更新工单签字记录
 * @param data 签字记录数据
 */
export const updateWorkOrderSignatureRecord = (data) => {
    return request.put(`/workorderSignatureRecord`, data);
}

/**
 * [删除]删除工单签字记录
 * @param id 签字记录id
 */
export const deleteWorkOrderSignatureRecord = (id) => {
    return request.delete(`/workorderSignatureRecord/${id}`);
}
